import React, { PropsWithChildren } from "react";
import { canManageOrderers } from "../common/helpers/municipalityRoles";
import MunicipalityRoleAuthorized from "./MunicipalityRoleAuthorized";

const OrdererManagementAuthorized = (props: PropsWithChildren<{}>) => (
    <MunicipalityRoleAuthorized
        canAccess={(user) => canManageOrderers(user.municipalityRole)}
    >
        {props.children}
    </MunicipalityRoleAuthorized>
);

export default OrdererManagementAuthorized;
